import React, {useContext, useEffect, useState, useMemo} from 'react';
import {Context} from '../../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import TablePagination from '../../../TablePagination';
import InputFilter from '../../../Filters/InputFilter';
import SelectComponent from '../../../Selects/SelectFilter';
import {getEstadosProposta, getPropostas, getTiposPropostas} from '../../../../pages/requests';
import Datepicker from 'react-tailwindcss-datepicker';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Spinner from '../../../../components/Spinner';
import NotFound from '../../../NotFound';
import axios from 'axios';
import moment from 'moment';
import {toast} from 'react-toastify';

function HistoricoPropostas({info}) {
    const FORMATO_DATA = 'YYYY-MM-DD';
    const {
        prospect,
        filtroId,
        setFiltroId,
        filtroTipoProposta,
        setFiltroTipoProposta,
        filtroDtProposta,
        setFiltroDtProposta,
        filtroCliente,
        setFiltroCliente,
        filtroEstado,
        setFiltroEstado,
        filtroLinhas,
        setFiltroLinhas,
        formattedDate,
        setFormattedDate,
        ids,
        setIds,
        tiposProposta,
        setTiposProposta,
        estados,
        setEstados,
    } = info;
    const {t} = useTranslation();
    const [historicoPropostas, setHistoricoPropostas] = useState([]);
    const {isCard, openCards} = useContext(Context);
    const [loading, setLoading] = useState(true);
    const [semDados, setSemDados] = useState(false);
    const [totalProdutos, setTotalProdutos] = useState(0);

    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 15;
    const [totalRegistos, setTotalRegistos] = useState(0);
    // const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    // const endIndex = startIndex + ITEMS_PER_PAGE;

    const [isMobile, setIsMobile] = useState(false);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    // FILTROS

    // const [filtroId, setFiltroId] = useState('');
    // const [filtroTipoProposta, setFiltroTipoProposta] = useState('');
    // const [filtroDtProposta, setFiltroDtProposta] = useState({
    //     startDate: '',
    //     endDate: '',
    // });
    // const [filtroCliente, setFiltroCliente] = useState('');
    // const [filtroEstado, setFiltroEstado] = useState('');
    // const [filtroLinhas, setFiltroLinhas] = useState('');
    // const [formattedDate, setFormattedDate] = useState('');

    // ARRAYS

    // const [ids, setIds] = useState([]);
    // const [tiposProposta, setTiposProposta] = useState([]);
    // const [estados, setEstados] = useState([]);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        debugger;
        setHistoricoPropostas([]);
        setLoading(true);

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

        getPropostas(
            indexOfFirstItem,
            indexOfLastItem - 1,
            lang,
            signal,
            filtroId,
            filtroTipoProposta?.value ?? '',
            filtroDtProposta.startDate ?? '',
            filtroDtProposta.endDate ?? '',
            prospect.codigoCliente,
            '',
            [],
            filtroEstado?.value,
        )
            .then(res => {
                if (res.data.success) {
                    if (res.data.propostas.length !== 0) {
                        setHistoricoPropostas(res.data.propostas);
                        setTotalRegistos(res.data.totalRegistos);
                    } else {
                        setSemDados(true);
                    }
                } else {
                    res.data.errorMessages.map(m =>
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 5000,
                        }),
                    );
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) console.log(error);
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [filtroId, filtroTipoProposta, filtroDtProposta, filtroEstado, currentPage]);

    useEffect(() => {
        getTiposPropostas(lang).then(res => {
            setTiposProposta(res.data.tiposOrcamento);
        });
        getEstadosProposta(lang).then(res => {
            setEstados(res.data.estados);
        });
    }, []);

    function limparFiltros() {
        setFiltroId('');
        setFiltroTipoProposta(null);
        setFiltroEstado(null);
        setCurrentPage(1);
        setFiltroDtProposta({startDate: null, endDate: null});
    }

    useEffect(() => {
        if (historicoPropostas.length == 0 && loading == false) {
            setSemDados(true);
        } else {
            setSemDados(false);
        }
    }, [historicoPropostas]);

    return (
        <>
            <div>
                {isMobile || isCard ? (
                    <div>
                        {historicoPropostas?.map((dados, index) => (
                            <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                <h2 className="mb-0" id="headingOne">
                                    <button
                                        className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                        type="button"
                                        data-te-collapse-init
                                        data-te-collapse-collapsed
                                        data-te-target={'#flush-collapseThree' + index}
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThree">
                                        <div className="flex flex-row">
                                            {dados.id} - {dados.tipoOrcamento.label}
                                        </div>
                                        <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    id={'flush-collapseThree' + index}
                                    className={openCards ? 'visible' : '!visible hidden'}
                                    data-te-collapse-item
                                    aria-labelledby="flush-headingThree"
                                    data-te-parent="#accordionFlushExample">
                                    <div className="px-5 py-4">
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('tipo')}:</div> {dados.tipoOrcamento.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('data')}: </div> {moment(dados.data).format(FORMATO_DATA)}
                                        </div>
                                        {/* <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('cliente')}: </div>
                                            {dados.cliente.nomeCliente}
                                        </div> */}
                                        <div className=" flex flex-row text-blue-600 dark:text-blue-500">
                                            <div className="font-medium text-gray-400 mr-2">{t('estado')}: </div> {dados.estado.label}
                                        </div>
                                        {/* <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('linhas')}: </div> {dados.linhas}
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        ))}

                        {/* {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )} */}
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>

                        <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>
                    </div>
                ) : (
                    <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        {t('id')}
                                        {/* <SelectComponent
                                        options={ids}
                                        value={filtroId ? filtroId.label : ''}
                                        onChange={e => {
                                            setFiltroId(e.label);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                        placeholder={t('filtro')}
                                    /> */}
                                        <InputFilter
                                            value={filtroId}
                                            onSearch={value => {
                                                setFiltroId(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className="px-6 py-3">
                                        {t('tipo')}
                                        <SelectComponent
                                            options={tiposProposta}
                                            value={filtroTipoProposta}
                                            onChange={e => {
                                                setFiltroTipoProposta(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('data')}
                                        <Datepicker
                                            displayFormat={FORMATO_DATA}
                                            useRange={false}
                                            asSingle={false}
                                            value={filtroDtProposta}
                                            onChange={newValue => {
                                                setFiltroDtProposta(newValue);
                                                setCurrentPage(1);
                                            }}
                                            inputClassName={`rounded-[8px] w-full mt-2 bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                        />
                                    </th>

                                    {/* <th scope="col" className="px-6 py-3 w-64">
                                        {t('estado')}
                                        <SelectComponent
                                            options={estados}
                                            value={filtroEstado ? filtroEstado.label : ''}
                                            onChange={e => {
                                                setFiltroEstado(e.label);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th> */}
                                    <th scope="col" className="px-6 py-3 w-80">
                                        {t('estado')}
                                        <div className="flex flex-row">
                                            <SelectComponent
                                                options={estados}
                                                value={filtroEstado}
                                                onChange={e => {
                                                    setFiltroEstado(e);
                                                    setCurrentPage(1);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('filtro')}
                                            />
                                            {filtroId || filtroTipoProposta || filtroDtProposta.startDate || filtroEstado ? (
                                                <button
                                                    onClick={limparFiltros}
                                                    type="button"
                                                    className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                    <FilterAltOffIcon />
                                                </button>
                                            ) : null}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {historicoPropostas.map(dados => (
                                    <tr
                                        className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                        // onClick={() => handleRowClick(dados)}
                                    >
                                        <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {dados.id}
                                        </th>
                                        <td className="px-6 py-1">{dados.tipoOrcamento.label}</td>
                                        <td className="px-6 py-1">{moment(dados.data).format(FORMATO_DATA)}</td>
                                        <td className="px-6 py-1 text-blue-600 dark:text-blue-500">{dados.estado.label}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {semDados && <NotFound frase={t('semRegistos')} />}

                        {totalProdutos === undefined && <NotFound frase={t('naoExistemClientes')} />}
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>

                        {loading && (
                            <div className="flex flex-row mt-14  justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
}

export default HistoricoPropostas;
